(function () {

    'use strict';

    angular.module('followUpModule')

    .factory('followUpService', ['$modal', '$rootScope', function ($modal, $rootScope) {
        
        var service = {};

        /**
         * Display Follow Ups in a modal
         * @param title {string} Modal title, tries to use the Plan Deliverable or Action Plan Criteria's title if title is null
         * @param [assessment] {Object} Assessment which contains the follow-ups
         * @param [followUps] {Array} List of follow-ups
         * @param [assessmentContainers] {Array} List of all assessments to get the current assessment from
         * @param [getDownloadAttachmentUrl] {function} Function used to get the attachment's URL. Function is called with the attachment's external ID
         * @returns {IScope|*|Object}
         */
        service.openFollowUpsModal = function(title, assessment, followUps, assessmentContainers, getDownloadAttachmentUrl) {
            var modalScope = $rootScope.$new();

            modalScope.assessment = assessment;
               
            modalScope.newFollowUp = {};
            modalScope.getDownloadAttachmentUrl = getDownloadAttachmentUrl;

            modalScope.currentFollowUps = followUps;
            if (!modalScope.currentFollowUps) {
                var currentContainer = _.find(assessmentContainers, function (cont) {
                    return cont.Assessment.GovernanceProcess.IsActive;
                });
                   
                if (currentContainer) modalScope.currentFollowUps = currentContainer.FollowUps;
            }

            modalScope.pastAssessmentContainers = _.chain(assessmentContainers)
                .reject(function (cont) { return cont.Assessment.GovernanceProcess.IsActive;})
                .reject(function(o) { return !o.FollowUps || !o.FollowUps.length; })
                .value();

            // if there is no assessment, look into all assessments to get the current assessment
            if (!assessment && assessmentContainers && assessmentContainers.length) {
                assessmentContainers.some(function(assessmentContainer) {
                    if (assessmentContainer.Assessment.GovernanceProcess.IsActive) {
                        modalScope.assessment = assessmentContainer.Assessment;
                        return true;
                    }
                });
            }

            modalScope.title = title ? title : modalScope.assessment ? getTitle(modalScope.assessment) : null;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/followUp/assessmentFollowUpsModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                showModal.$promise.then(showModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            function getTitle(assessment) {
                var obj = assessment.PlanDeliverable || assessment.ActionPlanCriteria;

                return obj ? obj.TitleEN : null;
            }

            return modalScope;
        };
        
        service.openRecommendationFollowUpsModal = function (title, recommendation, followUps, getDownloadAttachmentUrl) {
            var modalScope = $rootScope.$new();

            modalScope.auditMandate = recommendation;
            modalScope.currentFollowUps = followUps;
            modalScope.getDownloadAttachmentUrl = getDownloadAttachmentUrl;
            modalScope.title = title;

            modalScope.newFollowUp = {};
            
            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/followUp/recommendationFollowUpsModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                showModal.$promise.then(showModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            return modalScope;
        };
        return service;

    }]);

})();
